/**
 * Compares two dot-separated semver-ish version strings (e.g.
 *
 * @returns -1 when a < b, 0 when equal, 1 when a > b.
 */
export default function compareVersions(a: string, b: string): -1 | 0 | 1 {
	const parse = (version: string): number[] =>
		version
			.split('.')
			.map((segment) => Number.parseInt(segment, 10))
			.map((value) => (Number.isNaN(value) ? 0 : value));

	const left = parse(a);
	const right = parse(b);
	const length = Math.max(left.length, right.length);

	for (let index = 0; index < length; index++) {
		const leftValue = left[index] ?? 0;
		const rightValue = right[index] ?? 0;
		if (leftValue > rightValue) return 1;
		if (leftValue < rightValue) return -1;
	}

	return 0;
}
